import styled from '@emotion/styled'
import mq from 'theme/mediaQueries'
import { Card as UICard } from 'ui-components/Card'

export const Card = styled(UICard)`
  ${mq({
    padding: ['10px 0', '10px 0', '10px'],
  })}
`
